import React from 'react';
import { JsAudioDevice } from '../../../../../../../dualChannel/dualChannelTypes';

export default function useDefaultDevice(deviceId: string | null | undefined, options: JsAudioDevice[]) {
  return React.useMemo(() => {
    const defaultOption = options.find((elem) => elem.default) ?? options[0] ?? null;
    const currentOption = options.find((elem) => elem.id === deviceId);
    if (!currentOption) return defaultOption;
    return currentOption;
  }, [deviceId, options]);
}
